import { styled } from '@mui/material'
import Button from '@mui/material/Button'
import { COLORS } from '../../styles/colors'

export const ButtonCancel = styled(Button)(({ theme }) => ({
	backgroundColor: 'transparent',
	color: COLORS.secondary,

	// disable caps
	textTransform: 'none',

	// typography like TypographySecondary
	fontFamily: theme.typography.fontFamily,
	fontWeight: 400,
	fontSize: '12px',
	lineHeight: '15px',

	padding: 0,
	minWidth: 'auto',
	height: 'auto',

	'&:hover': {
		backgroundColor: 'transparent',
		color: COLORS.secondary,
	},

	'&:disabled': {
		backgroundColor: 'transparent',
		color: 'rgba(0, 0, 0, 0.38)',
		pointerEvents: 'none',
	},
}))
